import { RootState } from '../../../../rootReducer';

export const backFlowProcessesSelector = (state: RootState) => state.eventsLogModuleReducer.BackFlowProcessesReducer;
